module.exports = __webpack_public_path__ + "products/bump-scale-23df78b8890e99806e4299d8b389d5e0.svg";


//////////////////
// WEBPACK FOOTER
// ./images/products/bump-scale.svg
// module id = jalB
// module chunks = 2